if ($('#map').length) {
    var csvUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vReOTF3FH-MRV7IuKFLYfhTh4zdi1jtThA_60No2fmVn0qEa6cL4xeiHlhRXgaQS14Zejnwz5cMbrcF/pub?gid=0&single=true&output=csv';
    if($('body.mobile').length){
        var map = L.map('map').setView([49.8, 15.5], 6); // Center of Czech Republic
    }
    else{
        var map = L.map('map').setView([49.8, 15.5], 7); // Center of Czech Republic
    }
   

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);

    var customIcon = L.icon({
        iconUrl: '/user/documents/upload/sablona-nemazat/mapa-bod.svg',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34]
    });

    var headquartersIcon = L.icon({
        iconUrl: '/user/documents/upload/sablona-nemazat/sidlo-mydlenka.svg',
        iconSize: [30, 45],
        iconAnchor: [15, 45],
        popupAnchor: [1, -34]
    });
    Papa.parse(csvUrl, {
        download: true,
        header: true,
        delimiter: ",",
        complete: function(results) {
            var data = results.data;

            data.forEach(function(item) {
                var lat = parseFloat(item.latitude);
                var lon = parseFloat(item.longitude);

                if (!isNaN(lat) && !isNaN(lon)) {
                    var icon = item["Název dodacího místa"] === "Sídlo MýdLenka" ? headquartersIcon : customIcon;
                    var marker = L.marker([lat, lon], { icon: icon }).addTo(map);
                   // var popupContent = `<b>${item["název dodacího místa"]}</b><br>${item.ulice} ${item["č.p."]}, ${item.obec}, ${item.psč}`;
                   // marker.bindPopup(popupContent);
                    marker.on('click', function() {
                        marker.openPopup();
                        // Update the info panel content
                        var customMap = '<div class="title"><span class="closePoint"></span>'+item["Název dodacího místa"]+', '+item["Ulice"]+' '+item["Č.p."]+'</div>'
                        customMap += '<div class="name"><p><span>Název</span> '+item["Název dodacího místa"]+', '+item["Ulice"]+' '+item["Č.p."]+'</p></div>'
                        customMap += '<div class="googleMaps"><p><span>Podrobnosti z Map Google</span>'+item["Ulice"]+' '+item["Č.p."]+' '+item["Obec"]+'</p></div>'
                        if(item["Odkaz na mapu"] !== ''){
                            customMap += '<div class="googleMapsLink"><a href="'+item["Odkaz na mapu"]+'" target="_blank">Zobrazit v Mapách Google</a></div>'
                        }
                        if(item["Poznámka"] !== ''){
                            customMap += '<div class="remark"><p>'+item["Poznámka"]+'</p></div>'
                        }
                        if(item["Foto prodejny"] !== ''){
                            customMap += '<div class="image"><img src="'+item["Foto prodejny"]+'" alt="mydlenka"></div>'
                        }
                        $('#infoPanel').html(customMap)
                        $('#infoPanel').addClass('open');
                    });
                }
            });
        }
    });

    // Hide info panel on map click
    map.on('click', function() {
        $('#infoPanel').removeClass('open');
    });
    $(document).on('click', '.closePoint', function() {
        $('#infoPanel').removeClass('open');
    });
}